// src/TopicsPage.js
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { parseEther, formatEther } from "ethers";
// import { FaPlusCircle, FaMinusSquare } from 'react-icons/fa'; // Import icons

function ExistingTopics({ contract, signerContract }) {
    // const [account, setAccount] = useState("");
    const [topics, setTopics] = useState([]);
    const [message, setMessage] = useState("");
    const [log, setLog] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [secretPhrase, setSecretPhrase] = useState("");
    const [bonusAmount, setBonusAmount] = useState(""); // For raising bonus
    const [newMaxBetAmount, setNewMaxBetAmount] = useState(""); // For modifying max bet
    const [newMinBetAmount, setNewMinBetAmount] = useState(""); // For modifying min bet

    const [currentPage, setCurrentPage] = useState(1); // To track the current page
    const [topicsPerPage] = useState(5); // Number of topics to display per page

    useEffect(() => {//first useEffect
        const init = async () => {
            if (contract) {
                console.log("Calling load topics from first useEffect");
                
                await loadTopics(contract);//

                // Listen to the TopicCreated event directly
                contract.on("TopicCreated", (topicId, creator) => {
                    console.log("TopicCreated event received:", { topicId, creator });

                    // Handle the new topic creation
                    handleNewTopic(contract, topicId.toString(), creator);
                });
                // Listen for BonusRaised event
                contract.on("BonusRaised", (topicId, amountRaised, newBonusCoins) => {
                    console.log("BonusRaised event received:", { topicId, amountRaised, newBonusCoins });
                    handleBonusRaised(topicId, newBonusCoins);
                });

                // Listen for BetLimitsModified event
                contract.on("BetLimitsModified", (topicId, newMaxBetAmount, newMinBetAmount) => {
                    console.log("BetLimitsModified event received:", { topicId, newMaxBetAmount, newMinBetAmount });
                    handleBetLimitsModified(topicId, newMaxBetAmount, newMinBetAmount);
                });
            } else {
                console.error("Contract instance not found!");
            }
        };

        init();

        // Cleanup listener on component unmount
        return () => {
            if (contract) {
                contract.off("TopicCreated");
                contract.off("BonusRaised");
                contract.off("BetLimitsModified");
            }
        };
    }, [contract, currentPage]);

    useEffect(() => {//second useEffect
        const timer = setInterval(() => {
            const currentTime = Math.floor(Date.now() / 1000);
            setTopics((prevTopics) =>
                prevTopics.map((topic) => {
                    const startDatePassed = currentTime > Number(topic.startDate);
                    const endDatePassed = currentTime > Number(topic.endDate);

                    return {
                        ...topic,
                        startDatePassed: startDatePassed,
                        endDatePassed: endDatePassed,
                    };
                })
            );
        }, 1000);

        return () => clearInterval(timer);
    }, [topics]);

    // useEffect(() => {//third UseEffect
    //     if (contract) {
            
    //         console.log("Calling load topics from third useEffect");
    //         loadTopics(contract);
    //     }
    // }, [contract, currentPage]); // Trigger reload when currentPage changes

    const calculateTimeLeft = (startDate, endDate, startDatePassed) => {
        const now = BigInt(Math.floor(Date.now() / 1000)); // Ensure 'now' is BigInt
        let timeLeft;
        if (!startDatePassed) {
            timeLeft = BigInt(startDate) - now; // Convert startDate to BigInt
        } else if (endDate) {
            timeLeft = BigInt(endDate) - now; // Convert endDate to BigInt
        } else {
            timeLeft = BigInt(0);
        }
        return Number(timeLeft); // Convert BigInt to Number
    };

    const formatTimeLeft = (timeLeft) => {
        if (isNaN(timeLeft) || timeLeft <= 0) return "";

        const hours = Math.floor(timeLeft / 3600);
        const minutes = Math.floor((timeLeft % 3600) / 60);
        const seconds = timeLeft % 60;
        // console.log("Formated Time left: ", `${hours}h ${minutes}m ${seconds}s`);
        return `${hours}h ${minutes}m ${seconds}s`;
    };

    const formatTopic = async (contractInstance, topic, currentTime) => {
        if (!contractInstance) {
            console.error("Contract is not initialized.");
            return; // Early return to prevent further errors
        }
        if (!topic) {
            console.error("Received null topic");
            return;
        }
        const options = await contractInstance.getOptions(topic.id);
        const startDatePassed = currentTime > BigInt(topic.timing.startDate);
        const endDatePassed = currentTime > BigInt(topic.timing.endDate);
        // let timeLeft = null;
        // timeLeft = calculateTimeLeft(topic.startDate, topic.endDate, startDatePassed)

        return {
            id: topic.id.toString(),
            question: topic.question,
            options: options,
            pot: topic.betting.pot.toString(),          // Updated to access pot from Betting struct
            bonusCoins: topic.betting.bonusCoins.toString(),  // Updated to access bonusCoins from Betting struct
            maxBetAmount: formatEther(topic.betting.maxBetAmount.toString()),
            minBetAmount: formatEther(topic.betting.minBetAmount.toString()), // Add minBetAmount
            startDate: Number(topic.timing.startDate),   // Updated to access startDate from Timing struct
            endDate: Number(topic.timing.endDate),       // Updated to access endDate from Timing struct
            isExecuted: topic.isExecuted,
            isPredetermined: topic.isPredetermined,
            isCanceled: topic.isCanceled, // Ensure this property is included
            startDatePassed: startDatePassed,
            endDatePassed: endDatePassed,
            // timeLeft: timeLeft,
            creator: topic.creator,
            betAmount: "",
        };
    };
    const loadTopics = async (contractInstance) => {
        if (!contractInstance) {
            console.error("Contract is not initialized.");
            return; // Early return to prevent further errors
        }
        console.log("and another one");
        
        const topicsCount = await contractInstance.getTopicCounter(); // Assuming this returns BigInt
        const topics = [];
        const currentTime = Math.floor(Date.now() / 1000);

        // Convert topicsPerPage and currentPage to BigInt
        const topicsPerPageBigInt = BigInt(topicsPerPage);
        const currentPageBigInt = BigInt(currentPage);

        const end = topicsCount - (currentPageBigInt - 1n) * topicsPerPageBigInt; // Ensure BigInt arithmetic
        const start = end > topicsPerPageBigInt ? end - topicsPerPageBigInt : 0n; // Handle BigInt comparisons

        for (let i = end - 1n; i >= start; i--) {
            if (topics.some((t) => BigInt(t.id) === i)) {
                console.log(`Topic #${i} already loaded, skipping.`);
                continue; // Skip already loaded topics
            }
            const topic = await contractInstance.getTopic(i);

            const formattedTopic = await formatTopic(contractInstance, topic, currentTime);

            topics.push(formattedTopic);
        }

        setTopics((prevTopics) => [...prevTopics, ...topics]);
    };
    const handleLoadMore = async () => {
        setCurrentPage((prevPage) => prevPage + 1);
    };

    const handleNewTopic = async (contractInstance, topicId, creator) => {
        // console.log("New topic created:", topicId.toString(), creator);

        // Fetch the new topic details using the contract passed as a parameter
        const topic = await contractInstance.getTopic(topicId);
        const currentTime = Math.floor(Date.now() / 1000);
        const formattedTopic = await formatTopic(contractInstance, topic, currentTime);

        // Add the new topic at the beginning of the list only if it doesn't already exist
        setTopics((prevTopics) => {
            if (!prevTopics.some(t => t.id === topicId.toString())) {
                return [formattedTopic, ...prevTopics];
            }
            return prevTopics;
        });
    };
    const handleCancelTopic = async (topicId) => {
        try {
            const tx = await signerContract.cancelTopic(topicId);
            await tx.wait();
            const newLog = {
                action: `Cancel Topic ${topicId}`,
                timestamp: new Date().toLocaleString(),
                status: "success",
            };
            setLog([newLog, ...log.slice(0, 4)]);
            setMessage("Topic canceled successfully!");
            console.log("Calling load topics from handleCancelTopic");
            loadTopics(contract);
        } catch (error) {
            console.error("Error canceling topic:", error);
            const newLog = {
                action: `Cancel Topic ${topicId}`,
                timestamp: new Date().toLocaleString(),
                status: "Failed with error: " + (error.message || "Unknown error"),
            };
            setLog([newLog, ...log.slice(0, 4)]);
            setMessage("Failed to cancel topic.");
        }
    };
    const handlePlaceBet = async (topicId, optionIndex) => {
        try {
            const tx = await signerContract.placeBet(topicId, optionIndex, {
                value: parseEther(topics.find(topic => topic.id === topicId).betAmount),
            });
            await tx.wait();
            const newLog = {
                action: `Place Bet on Topic ${topicId}`,
                timestamp: new Date().toLocaleString(),
                status: "success",
            };
            setLog([newLog, ...log.slice(0, 4)]);
            setMessage("Bet placed successfully!");
            console.log("Calling load topics from handlePlaceBet");
            loadTopics(contract);
        } catch (error) {
            console.error("Error placing bet:", error);
            const newLog = {
                action: `Place Bet on Topic ${topicId}`,
                timestamp: new Date().toLocaleString(),
                status: "Failed with error: " + (error.message || "Unknown error"),
            };
            setLog([newLog, ...log.slice(0, 4)]);
            setMessage("Failed to place bet.");
        }
    };
    const handleBetAmountChange = (topicId, value) => {
        const updatedTopics = topics.map((topic) => {
            if (topic.id === topicId) {
                const exceedsMaxBet = parseFloat(value) > parseFloat(topic.maxBetAmount);
                const belowMinBet = parseFloat(value) < parseFloat(topic.minBetAmount);
                return {
                    ...topic,
                    betAmount: value,
                    errorMessage: exceedsMaxBet
                        ? `Bet amount exceeds max allowed of ${topic.maxBetAmount} 6DO`
                        : belowMinBet
                            ? `Bet amount is below the minimum required of ${topic.minBetAmount} 6DO`
                            : ""
                };
            }
            return topic;
        });
        setTopics(updatedTopics);
    };
    const handleRevealAndExecute = async (topicId, correctOptionIndex) => {
        try {

            const tx = await signerContract.revealAndExecute(topicId, correctOptionIndex, secretPhrase);
            await tx.wait();
            const newLog = {
                action: `Reveal and Execute Topic ${topicId}`,
                timestamp: new Date().toLocaleString(),
                status: "success",
            };
            setLog([newLog, ...log.slice(0, 4)]);
            setMessage(" Topic executed successfully!");
            console.log("Calling load topics from handleRevealAndExecute");
            loadTopics(contract);
        } catch (error) {
            console.error("Error executing topic:", error);
            const newLog = {
                action: `Reveal and Execute Topic ${topicId}`,
                timestamp: new Date().toLocaleString(),
                status: "Failed with error: " + (error.message || "Unknown error"),
            };
            setLog([newLog, ...log.slice(0, 4)]);
            setMessage("Failed to execute  Topic.");
        }
    };
    // Function to raise bonus for a topic
    const handleRaiseBonus = async (topicId, bonusAmount) => {
        try {
            const tx = await signerContract.raiseBonus(topicId, {
                value: parseEther(bonusAmount), // Convert bonusAmount to Wei
            });
            await tx.wait();

            const newLog = {
                action: `Raise Bonus for Topic ${topicId}`,
                timestamp: new Date().toLocaleString(),
                status: "success",
            };
            setLog([newLog, ...log.slice(0, 4)]);
            setMessage(`Bonus raised successfully for Topic ${topicId}!`);
            console.log("Calling load topics from handleRaiseBonus");
            loadTopics(contract); // Reload topics after the operation
        } catch (error) {
            console.error("Error raising bonus:", error);
            const newLog = {
                action: `Raise Bonus for Topic ${topicId}`,
                timestamp: new Date().toLocaleString(),
                status: "Failed with error: " + (error.message || "Unknown error"),
            };
            setLog([newLog, ...log.slice(0, 4)]);
            setMessage(`Failed to raise bonus for Topic ${topicId}.`);
        }
    };

    // Function to modify the bet limits for a topic
    const handleModifyBetLimits = async (topicId, newMaxBetAmount, newMinBetAmount) => {
        try {
            const tx = await signerContract.modifyBetLimits(
                topicId,
                parseEther(newMaxBetAmount),  // Convert maxBetAmount to Wei
                parseEther(newMinBetAmount)   // Convert minBetAmount to Wei
            );
            await tx.wait();

            const newLog = {
                action: `Modify Bet Limits for Topic ${topicId}`,
                timestamp: new Date().toLocaleString(),
                status: "success",
            };
            setLog([newLog, ...log.slice(0, 4)]);
            setMessage(`Bet limits modified successfully for Topic ${topicId}!`);
            console.log("Calling load topics from handleModifyBetLimits");
            loadTopics(contract); // Reload topics after the operation
        } catch (error) {
            console.error("Error modifying bet limits:", error);
            const newLog = {
                action: `Modify Bet Limits for Topic ${topicId}`,
                timestamp: new Date().toLocaleString(),
                status: "Failed with error: " + (error.message || "Unknown error"),
            };
            setLog([newLog, ...log.slice(0, 4)]);
            setMessage(`Failed to modify bet limits for Topic ${topicId}.`);
        }
    };
    const handleBonusRaised = (topicId, newBonusCoins) => {
        setTopics((prevTopics) =>
            prevTopics.map((topic) => {
                if (topic.id === topicId.toString()) {
                    return {
                        ...topic,
                        bonusCoins: newBonusCoins, // Update the bonusCoins
                    };
                }
                return topic;
            })
        );
    };
    const handleBetLimitsModified = (topicId, newMaxBetAmount, newMinBetAmount) => {
        setTopics((prevTopics) =>
            prevTopics.map((topic) => {
                if (topic.id === topicId.toString()) {
                    return {
                        ...topic,
                        maxBetAmount: formatEther(newMaxBetAmount), // Update the maxBetAmount
                        minBetAmount: formatEther(newMinBetAmount), // Update the minBetAmount
                    };
                }
                return topic;
            })
        );
    };

    return (
        <div className="container mt-5">
            <Helmet>
                <title>6Degree - Explore Existing  Topics on the Blockchain</title>
                <meta name="description" content="Browse and participate in existing  topics on 6Degree. Join the decentralized betting community today." />
            </Helmet>
            <h1>Existing  Topics</h1>
            {topics.map((topic) => (
                <div key={topic.id} className="mb-3">
                    <h5>
                        Topic #{topic.id}: {topic.question}
                    </h5>
                    <div>
                        Pot: {formatEther(topic.pot.toString())} 6DO
                        + {formatEther(topic.bonusCoins.toString())} 6DO Bonus
                        {/* Allow raising bonus if the topic has not passed the end date */}
                        {!topic.isExecuted && !topic.endDatePassed && (
                            <div className="d-flex">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter additional bonus amount in 6DO"
                                    onChange={(e) => setBonusAmount(e.target.value)}  // Add a state for bonusAmount
                                />
                                <button
                                    onClick={() => handleRaiseBonus(topic.id, bonusAmount)}
                                    className="btn btn-success ml-2"
                                >
                                    Raise Bonus
                                </button>
                            </div>
                        )}
                    </div>
                    <p>Total: {formatEther((BigInt(topic.pot) + BigInt(topic.bonusCoins)).toString())} 6DO</p>
                    <p>Min Bet Amount: {topic.minBetAmount} 6DO</p> {/* Display minBetAmount */}
                    <p>Max Bet Amount: {topic.maxBetAmount} 6DO</p>
                    {/* Allow modifying bet limits if the topic has not passed the end date */}
                    {!topic.isExecuted && !topic.endDatePassed && (
                        <div className="d-flex">
                            <input
                                type="text"
                                className="form-control ml-2"
                                placeholder="New Min Bet Amount"
                                onChange={(e) => setNewMinBetAmount(e.target.value)}  // Add a state for newMinBetAmount
                            />
                            <input
                                type="text"
                                className="form-control"
                                placeholder="New Max Bet Amount"
                                onChange={(e) => setNewMaxBetAmount(e.target.value)}  // Add a state for newMaxBetAmount
                            />
                            <button
                                onClick={() => handleModifyBetLimits(topic.id, newMaxBetAmount, newMinBetAmount)}
                                className="btn btn-primary ml-2"
                            >
                                Modify Bet Limits
                            </button>
                        </div>
                    )}
                    <p>Status:</p>
                    <ul>
                        <li>
                            {!topic.startDatePassed ? (
                                `Starts in: ${formatTimeLeft(calculateTimeLeft(topic.startDate, topic.endDate, topic.startDatePassed))}`
                            )
                                :

                                (!topic.endDatePassed ? (
                                    `Ends in: ${formatTimeLeft(calculateTimeLeft(topic.startDate, topic.endDate, topic.startDatePassed))}`
                                )
                                    :

                                    (`Time's up! Betting ended on ${new Date(topic.endDate * 1000).toLocaleString()}`)
                                )
                            }
                        </li>
                        <li>
                            {topic.isExecuted ? (
                                "Executed"
                            ) : topic.isCanceled ? (
                                "Canceled"
                            ) : (
                                <>
                                    Not Executed
                                    {topic.endDatePassed && (
                                        <>
                                            <select
                                                className="form-control d-inline-block w-auto ml-2"
                                                onChange={(e) => setSelectedOption(e.target.value)}
                                                disabled={topic.isExecuted}
                                            >
                                                <option value="">Select Correct Option</option>
                                                {topic.options.map((option, i) => (
                                                    <option key={i} value={i}>
                                                        {option}
                                                    </option>
                                                ))}
                                            </select>
                                            {topic.isPredetermined && (
                                                <>
                                                    <input
                                                        type="text"
                                                        className="form-control d-inline-block w-auto ml-2"
                                                        placeholder="Secret Phrase"
                                                        value={secretPhrase}
                                                        onChange={(e) => setSecretPhrase(e.target.value)}
                                                        disabled={topic.isExecuted}
                                                    />
                                                </>
                                            )}
                                            <button
                                                onClick={() => handleRevealAndExecute(topic.id, selectedOption)}
                                                className="btn btn-warning ml-2"
                                                disabled={topic.isExecuted || selectedOption === null}
                                            >
                                                Reveal and Execute
                                            </button>
                                        </>
                                    )}
                                    {/* Display Cancel button if the topic is in progress and not executed */}
                                    {!topic.isExecuted && !topic.endDatePassed && (
                                        <button
                                            onClick={() => handleCancelTopic(topic.id)}
                                            className="btn btn-danger ml-2"
                                        >
                                            Cancel Topic
                                        </button>
                                    )}
                                </>
                            )}
                        </li>
                    </ul>
                    <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Enter bet amount in 6DO"
                        value={topic.betAmount}
                        onChange={(e) => handleBetAmountChange(topic.id, e.target.value)}
                        disabled={topic.isCanceled || topic.endDatePassed || topic.isExecuted || !topic.startDatePassed}
                    />
                    {topic.errorMessage && (
                        <div className="alert alert-danger mt-2">
                            {topic.errorMessage}
                        </div>
                    )}
                    {topic.options && topic.options.map((option, i) => (
                        <button
                            key={i}
                            onClick={() => handlePlaceBet(topic.id, i, "0.1")}
                            className={`btn ${topic.isCanceled || topic.endDatePassed || topic.isExecuted || !topic.startDatePassed ? 'btn-secondary' : 'btn-primary'} mr-2`}
                            disabled={topic.isCanceled || topic.endDatePassed || topic.isExecuted || !topic.startDatePassed}
                        >
                            Bet on {option}
                        </button>
                    ))}
                </div>
            ))}
            {topics.length > 0 && topics.length % topicsPerPage === 0 && (
                <button className="btn btn-primary mt-3" onClick={handleLoadMore}>
                    Load More
                </button>
            )}
            {message && <div className="alert alert-info mt-4">{message}</div>}
            <div className="mt-5">
                <h4>Log</h4>
                <ul>
                    {log.map((entry, index) => (
                        <li key={index} style={{ color: entry.status === "fail" ? "red" : "black" }}>
                            [{entry.timestamp}] {entry.action} - {entry.address} - {entry.status}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default ExistingTopics;